import { render, staticRenderFns } from "./Weddinglinks.vue?vue&type=template&id=19a26f7e&"
import script from "./Weddinglinks.vue?vue&type=script&lang=js&"
export * from "./Weddinglinks.vue?vue&type=script&lang=js&"
import style0 from "./Weddinglinks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Weddinglinks.vue"
export default component.exports